var $ = require('jQuery');

/**
 * Tagger Class
 *
 * Tag selected items.
 */
module.exports = function(marker, revealer) {
    var form = $("#marker-action-tag");
    var tagsInput = form.find('.tags-input');
    var tagging = $("#reveal-action-tagging");

    // Handle showing/hiding of bulk tagging form
    this.revealerClicked = function() {
        revealer.toggle(tagging);
    };

    // Handle tagging
    this.tagClicked = function() {
        // If there are no tokens, return
        if (isEmpty()) return;

        marker.addIdsToForm(form);

        if(marker.idsExist()) {
            form.submit();
        } else {
            marker.displayError();
        }
    };

    // Counts all tokens
    var isEmpty = function() {
        return tagsInput.find('input[name="tags"]').val() == '';
    };

    // jQuery Bindings
    $("#reveal-action-tagging .marker-action-button").on("click", this.revealerClicked);
    $("#marker-action-tag .marker-action-button").on("click", this.tagClicked);
};
